import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { logBuildInfo } from './utils/environment';
import { initCSPMonitoring } from './utils/cspMonitor';
import { installGlobalErrorHandlers } from './utils/errorReporter';

// Initialize monitoring and logging
logBuildInfo();
initCSPMonitoring();
installGlobalErrorHandlers(); // capture uncaught errors + promise rejections → backend

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);